import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";

@Component({
  selector: "sm-update-interest-status-reply",
  templateUrl: "./update-interest-status-reply.component.html",
  styleUrls: ["./update-interest-status-reply.component.scss"],
})
export class UpdateInterestStatusReplyComponent implements OnInit {
  reply: any;
  apisub: Subscription;
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentdata: any,
    private apiservice: ApiService,
    private loader: LoaderServiceService,
    private activemodal: MatDialogRef<UpdateInterestStatusReplyComponent>
  ) {
    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_UPDATE_ENROLL_STATUS
      ) {
        if (resdata.result) {
          this.activemodal.close({ msg: "success" });
        }
      }
    });
  }

  ngOnInit(): void {}

  onPost() {
    let obj = {
      hash_id: this.parentdata.data.hash_id,
      entity_hash: this.parentdata.entityHash,
      entity_reply: this.reply,
      status: this.parentdata.data.enrollment_request_status,
      reply_date: this.formatDateStringforcancel(new Date()),
      created_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
      creation_time: this.formatDateStringforcancel(new Date()),
    };
    this.loader.showLoader = true;
    this.apiservice.updateEnrollInterestStatus(obj);
  }
  formatDateStringforcancel(datestr: Date): string {
    const now = new Date(datestr);

    const options: Intl.DateTimeFormatOptions = {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false, // Ensures 24-hour format
    };

    const formattedDate = new Intl.DateTimeFormat(
      "en-CA",
      options
    ).formatToParts(now);

    let year = "",
      month = "",
      day = "",
      hours = "",
      minutes = "",
      seconds = "";

    formattedDate.forEach((part) => {
      if (part.type === "year") year = part.value;
      if (part.type === "month") month = part.value;
      if (part.type === "day") day = part.value;
      if (part.type === "hour") hours = part.value;
      if (part.type === "minute") minutes = part.value;
      if (part.type === "second") seconds = part.value;
    });

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
}
